import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { Separator } from '@/components/ui/separator';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarSeparator',
  props: {
    class: {}
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Separator), {
    "data-slot": "sidebar-separator",
    "data-sidebar": "separator",
    class: _normalizeClass(_unref(cn)('bg-sidebar-border mx-7 my-2 w-auto!', props.class))
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})